import Panel from '../components/panel'
import {Button} from '../components//button'
import PropertyInput from "../components/inputs/input-property.tsx";

import { useStore } from "../state/state.ts";
import { PanelImg } from '../components/img.tsx';
import { ModalClose } from '../components/modal-close.tsx';
import "./modal_info_co2preis.css";

import co2_2030 from "../assets/co2-abgabe-bis-2030.svg";
import co2_2040 from "../assets/co2-abgabe-bis-2040.svg";
import co2_2044 from "../assets/co2-abgabe-bis-2044.svg";


export default function ModalInfoCO2Preis() {
    const pop_modal = useStore((state)=>state.pop_modal);
    
  return <><Panel >
            <h1 id="modal-title">CO₂-Preis</h1>
            <p id="modal-description">Dieser Wert ist voreingestellt, kann aber für die Berechnung der CO2-Steuerersparnis individuell eingestellt werden. Der CO2-Preis ist als Zusatzausgabe für klimaschädliche Brenn- und Kraftstoffe wie Erdgas und Heizöl ist von Hauseigentümern zu tragen. Der CO2-Preis liegt 2025 bei 55 € pro Tonne CO2 und richtet sich ab 2026 danach, wie teuer Emissionszertifikate im Europäischen Emissionshandel für Gebäude und Verkehr gehandelt werden. Je effizienter ein Haus durch die geplanten Maßnahmen wird, desto höher ist die CO2-Steuerersparnis.</p>

            {/* <style>
                * { margin: 0; padding: 0; box-sizing: border-box; }
                body { background: #1a1a1a; color: #fff; font-family: Arial, Helvetica, sans-serif; padding: 30px; }
                figure { margin: 0 0 50px 0; }
                h2 { font-size: 18px; font-weight: var(--font-weight-bold); margin-bottom: 4px; }
                h2 sub { font-size: 14px; }
                .source { font-size: 10px; color: #aaa; margin-bottom: 16px; line-height: 1.5; }
                .legend { display: flex; gap: 24px; margin-bottom: 10px; font-size: 13px; }
                .legend-item { display: flex; align-items: center; gap: 6px; }
                .legend-line { width: 30px; height: 3px; }
                svg text { font-family: Arial, Helvetica, sans-serif; }
            </style> */}

            <figure className="figure_co2_price">
            <h2>Mögliche Preisszenarien für die Entwicklung <br></br> der CO<sub>2</sub>-Abgabe bis 2045 <br></br> CO<sub>2</sub>-Abgabe für 1t CO<sub>2</sub>-Emissionen <br></br>(in Euro ohne MwSt.)</h2>
            <legend className="legend">
                <div className="legend-item"><div className="legend-line" style={{background:"#e89a2e"}}></div> Gelb: Moderates-Preisszenario</div>
                <div className="legend-item"><div className="legend-line" style={{background:"#4caf50"}}></div> Grün: Sprung-100/240-Szenario</div>
                <div className="legend-item"><div className="legend-line" style={{background:"#e53935"}}></div> Rot: Sprung-130/300-Szenario</div>
            </legend>

            <div className='figure-col-3'>
                <figure>
                    <legend>
                        CO₂-Abgabe bis 2030
                    </legend>
                    <img alt="Balkendiagram Co2-Abgabe 2030 (Gelb: 4.550, Grün: 6.400, Rot: 8.200)" src={co2_2030}></img>
                </figure>
                <figure>
                    <legend>
                        CO₂-Abgabe bis 2040
                    </legend>
                    <img alt="Balkendiagram Co2-Abgabe 2040 (Gelb: 17.475, Grün: 28.050, Rot: 36.000) " src={co2_2040}></img>
                </figure>
                <figure>
                    <legend>
                        CO₂-Abgabe bis 2044
                    </legend>
                    <img alt="Balkendiagram Co2-Abgabe 2044 (Gelb: 25.025, Grün: 37.650, Rot: 48.000) " src={co2_2044}></img>
                </figure>
            </div>
            <p className="source">
                Quelle: Bundesministerium für Wirtschaft und Energie / Bundesministerium für Wohnen, Stadtentwicklung und Bauwesen
                Informationen vor dem Einbau einer neuen Heizung als Grundlage zur im GEG § 71 Abs. 11 GEG 2024 vorgeschriebenen Beratungspflicht
            </p>
            </figure>

            <ModalClose label={"schließen"} onClick={()=>{
                pop_modal();
            }}/>
         </Panel>
    </>;
}

